import * as React from 'react';

import type { IconProps } from './types';

export const InfoCircledIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="15px"
    width="15px"
    xmlns="http://www.w3.org/2000/svg"
    ref={forwardedRef}
    {...props}
  >
    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path>
  </svg>
));
InfoCircledIcon.displayName = 'InfoCircled';

export default InfoCircledIcon;
